import { useTranslation } from 'react-i18next';
import SystemStatus from '@libs/SystemStatus';
import useStatusFilter, {
  ButtonFilter as ButtonFilterConst,
} from '@pages/sharedHooks/useStatusFilter';

export const ButtonFilter = ButtonFilterConst;

const useStatusBackupFilter = (onFilter) => {
  const { t } = useTranslation();
  const { listBackupStatus } = SystemStatus;

  const listFilter = [
    {
      label: 'system_status.completed_text',
      status: listBackupStatus.SUCCESS,
    },
    {
      label: 'system_status.running_text',
      status: listBackupStatus.RUNNING,
    },
    {
      label: 'system_status.authentication_error_text',
      status: listBackupStatus.AUTHENTICATION_ERROR,
    },
  ];

  const headingText = t('status_backup_page.search_block.filter_by_backup_status_text');

  const {
    filterData,
    showDrawer,
    setShowDrawer,
    handleFilter,
    handleOpenDrawer,
    listBadges,
    handleDelete,
  } = useStatusFilter({ onFilter, listFilter, headingText });

  return {
    filterData,
    showDrawer,
    setShowDrawer,
    handleFilter,
    handleOpenDrawer,
    listBadges,
    handleDelete,
  };
};

export default useStatusBackupFilter;
